exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ .ui-fileupload button[icon=fa-upload] {\n  display: none; }\n\n:host /deep/ .ui-fileupload button[ng-reflect-label=Cancel] {\n  display: none; }\n\n:host /deep/ .ui-fileupload-content {\n  height: 100px;\n  padding: 0;\n  margin-bottom: 10px;\n  position: relative; }\n\n:host /deep/ p-progressbar {\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%; }\n\n:host /deep/ .ui-fileupload-files {\n  display: block;\n  height: 100px;\n  overflow: auto;\n  padding: 10px 0 0; }\n\n:host /deep/ .ui-fileupload-row img {\n  max-height: 70px;\n  max-width: 50px;\n  width: auto; }\n\n:host /deep/ .ui-fileupload-row button {\n  border-color: #b43128;\n  background-color: #d9534f; }\n  :host /deep/ .ui-fileupload-row button:enabled:hover, :host /deep/ .ui-fileupload-row button:focus {\n    border-color: #9e2b23;\n    background-color: #b43128; }\n\n:host /deep/ .multiple .ui-fileupload-content, :host /deep/ .multiple .ui-fileupload-files {\n  height: 300px; }\n\n.uploader-dialog {\n  width: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/uploader/modal-uploader/modal-uploader.component.scss
// module id = ../../../../../src/app/uploader/modal-uploader/modal-uploader.component.scss
// module chunks = main